import { useTranslation } from "react-i18next";

import { ProductFinderOverviewInitialTab } from "../../../../commons/types/settings";
import * as icons from "../../../../resources/icons";
import Icon from "../../../commons/components/Icon/Icon";
import IconLink from "../../../commons/components/IconLink/IconLink";
import CategoriesContent from "../../../commons/container/ProductFinderOverview/CategoriesContent";
import DetailsContent from "../../../commons/container/ProductFinderOverview/DetailsContent";
import ProductFinderOverviewPartial, {
  RouteDefinition
} from "../../../commons/container/ProductFinderOverview/ProductFinderOverviewPartial";
import SearchContent from "../../../commons/container/ProductFinderOverview/SearchContent";
import { useAppHistory, useAppLocation } from "../../../commons/libs/hooks/use-app-routing";
import { ROUTES } from "../../../commons/routes";
import { useMobileAppDispatcher, useMobileAppSelector } from "../../store/hooks";

import BrandsContent from "./BrandsContent";

const ProductFinderOverview = () => {
  const hasEnteredThroughDeepLink = useMobileAppSelector(state => state.mobile.hasEnteredThroughDeepLink);
  const [dispatch, actions] = useMobileAppDispatcher();
  const { t } = useTranslation(["mobile"]);
  const history = useAppHistory();
  const location = useAppLocation();

  const productFinderOverviewRoutes: RouteDefinition[] = [
    {
      path: ROUTES.PRODUCT_FINDER_OVERVIEW.BRANDS,
      component: BrandsContent,
      title: t("mobile:productFinderOverview.brands"),
      value: ProductFinderOverviewInitialTab.Brands
    },
    {
      path: ROUTES.PRODUCT_FINDER_OVERVIEW.CATEGORIES,
      component: CategoriesContent,
      title: t("mobile:productFinderOverview.categories"),
      value: ProductFinderOverviewInitialTab.Categories
    },
    {
      path: ROUTES.PRODUCT_FINDER_OVERVIEW.DETAILS,
      component: DetailsContent,
      title: t("mobile:productFinderOverview.details"),
      value: ProductFinderOverviewInitialTab.Details,
      props: {
        isOnline: true
      }
    },
    {
      path: ROUTES.PRODUCT_FINDER_OVERVIEW.SEARCH,
      component: SearchContent,
      title: t("mobile:productFinderOverview.search"),
      value: ProductFinderOverviewInitialTab.Search
    }
  ];

  const renderBackButton = () => {
    const onClick = () => {
      // To prevent a mobile user from accidentally exiting the app when he enters through a deep link,
      // we redirect in place (don't push), to the main page to start a new history
      if (hasEnteredThroughDeepLink) {
        // We reset the hasEnteredThroughDeepLink-state to prevent a loop
        dispatch(actions.mobile.setHasEnteredThroughDeepLink(false));
        history.replace(ROUTES.NAVIGATION.INDEX);
      } else {
        if (location.state?.goBackToDetails) {
          history.go(-2);
        } else {
          history.goBack();
        }
      }
    };

    const label = hasEnteredThroughDeepLink
      ? t("mobile:productFinderOverview.backToMainMenuButton")
      : t("mobile:productFinderOverview.backButton");

    return (
      <IconLink onClick={onClick} icon={<Icon source={icons.IconSmallArrowLeft} />} size="l">
        {label}
      </IconLink>
    );
  };

  return (
    <ProductFinderOverviewPartial
      isOffline={false}
      backButton={renderBackButton()}
      productFinderOverviewRoutes={productFinderOverviewRoutes}
    />
  );
};

export default ProductFinderOverview;
